import React, { useEffect, useState } from 'react';
import SettingsHero from './components/SettingsHero';
import ProfileView from './components/ProfileView';
import ProfileEdit from './components/ProfileEdit';
// import YourExams from './components/YourExams';
import AccountView from './components/AccountView';
import { axiosRequest } from '../../../_config/apiClient';
import { showError } from '../../../_config/toastUtil';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('Settings');
  const [isEditing, setIsEditing] = useState(false);

  const [profileData, setProfileData] = useState({
    name: '',
    email: '',
    phone: '',
    image: '',
    location: '',
    dob: '',
    education: '',
    category: '',
  });
  const [loading, setLoading] = useState(false);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);

      const res = await axiosRequest(
        "post",
        "/user/userProfile",
        {},
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        }
      );

      setProfileData({
        name: res.data.name || '',
        email: res.data.email || '',
        phone: res.data.phone || '',
        image: res.data.image || '',
        location: res.data.location || '',
        dob: res.data.dob || '',
        education: res.data.education || '',
        category: res.data.category || '',
      });
    } catch (err) {
      console.error("User profile error", err);
      showError("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const updateUserProfile = async (updatedData) => {
    try {
      setLoading(true);

      let payload = {
        name: updatedData.name,
        location: updatedData.location,
        dob: updatedData.dob,
        education: updatedData.education,
        category: updatedData.category,
        language: updatedData.language,
        image: updatedData.image,
      };

      const res = await axiosRequest(
        "post",
        "/user/userUpdate",
        payload,
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        }
      );

      // assume backend updated profile return karta hai
      setProfileData(res.data || updatedData);
      setIsEditing(false);
    } catch (err) {
      console.error("Update profile error", err);
      showError("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };


  if (loading || !profileData) {
    return (
      <div className="w-full py-20 text-center text-gray-500">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="w-full pb-10">
      <SettingsHero activeTab={activeTab} setActiveTab={setActiveTab} />
      {activeTab === 'Settings' && (
        !isEditing ? (
          <ProfileView data={profileData} onEdit={() => setIsEditing(true)} />
        ) : (
          <ProfileEdit
            data={profileData}
            onSave={updateUserProfile}
            onCancel={() => setIsEditing(false)}
          />
        )
      )}

      {/* {activeTab === 'Your Exams' && <YourExams />} */}

      {activeTab === 'Account' && (
        <AccountView data={profileData} />
      )}
    </div>
  );
};

export default SettingsPage;